import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "../pages/pre_processor/Dashboard/index";
import Newproject from "../pages/pre_processor/NewProject/index";
import UploadBatchRecords from "../pages/pre_processor/UploadBatchRecords";
// import ChangePassword from "../components/AuthPages/Forgot_Password/PasswordChange";
import NewBatch from "../pages/pre_processor/NewBatch/index";
import UploadTemplateData from "../pages/pre_processor/UploadTemplateData/index";
import UploadPdfAgainstBatch from "../pages/pre_processor/UploadPdfAgainstBatch";
import PasswordChange from "../components/AuthPages/Forgot_Password/PasswordChange";
import BatchProcess from "../pages/pre_processor/BatchProcess";
import MapData from "../pages/pre_processor/MapData/index";
import ListPage from "../pages/administrator/ListPage/index";
import AddGroup from "../pages/administrator/AddGroup/index";
import ManageUser from "../pages/administrator/ManageUser/index";
import BatchProcessPreProcessor from "../pages/pre_processor/PreProcessorUserPermission/index";
import UserForm from "../pages/administrator/UserForm/index";
import DataReport from "../pages/administrator/DataDeletion/index";
import UploadBatchRecord from "../pages/administrator/UploadBatchRecords/index";
import OutputList from "../pages/administrator/OutputFormat/index";
// import PreviewOpFile from "../pages/administrator/OutputFormat/PreviewOpFile";
import ReviewBatchRecords from "../pages/administrator/ReviewBatchRecords/ReviewBatchRecords";
import BatchProcessProcessor from "../pages/processor/ProcessorUserPermission/index";
import AuditList from "../pages/administrator/AuditTrail/AuditList/index";
import AuditDetails from "../pages/administrator/AuditTrail/AuditDetails/AuditDetails";
import ValidatorDashboard from "../pages/validator/Dashboard/index";
import ProcessorDashboard from "../pages/processor/Dashboard/index";
import DataEntry from "../pages/processor/DataEntry/index";
import DataValidation from "../pages/validator/DataValidation/index";
import ListDirectory from "../pages/administrator/UploadBatchRecords/ListDirectory";
import BatchMonitor from "../pages/administrator/BatchDetails/index";
import AuditHistory from "../pages/administrator/AuditTrail/auditHistory/index";
import AuditUserActivity from "../pages/administrator/AuditTrail/UserActivity/index";
import {
  adminRoutes,
  authRoutes,
  preProRoutes,
  proRoutes,
  valiRoutes,
  sharedRoutes,
} from "./routeConstants";
import PageNotFound from "../components/PageNotFound";
import DataPointCalculation from "../pages/administrator/DpCalculation/index";
import DataPointDetails from "../pages/administrator/OutputFormat/DataPointDetails";
import MergeOpFiles from "../pages/administrator/MergeOpFiles/index";
import MergePDF from "../pages/administrator/MergePDF/MergePdf";
import MergePdfSelect from "../pages/administrator/MergePDF/index";
import TemplateCreation from "../pages/administrator/TemplatesCreation/index";
import VisualizationDashboardTables from "../pages/administrator/Visualization/DashboardTable";
import BatchRejection from "../pages/administrator/BatchRejection/DashboardTable";
import ExtractionDetails from "../components/ExtractionDetails";
import VisualizationHistoryTables from "../pages/administrator/VisualizationHistory";
// import Logs from "../pages/administrator/AuditLogs";
import DataHistory from "../pages/administrator/DataHistory/index";
import FilesViewer from "../pages/administrator/ViewFiles/FilesViewer";
// import Sidebar from "../components/LeftSideBar/CAMDrawer";
import BulkBatchCreation from "../pages/pre_processor/BulkBatch";
import { useLocation } from "react-router-dom";
import ValidatorUserPermission from "../pages/validator/validatorUserPermission";
import ApprovalSettings from "../pages/administrator/application_configs/ApprovalSettings";

const PreProcessorRoutes = () => {
  const navigate = useNavigate(); // Use useNavigate instead of withRouter
  return (
    <Routes>
      <Route
        path={`/${preProRoutes?.preProDashboard}`}
        element={<Dashboard />}
      />
      <Route path={`/${preProRoutes?.newProject}`} element={<Newproject />} />
      <Route
        path={`/${preProRoutes?.uploadBatchRecord}`}
        element={<UploadBatchRecords navigate={navigate} />}
      />
      <Route path={`/${preProRoutes?.newBatch}`} element={<NewBatch />} />
      <Route
        path={`/${preProRoutes?.uploadTemplateData}`}
        element={<UploadTemplateData />}
      />
      <Route
        path={`/${preProRoutes?.uploadPdfAgainstBatch}`}
        element={<UploadPdfAgainstBatch />}
      />
      <Route
        path={`/${preProRoutes?.batchProcess}`}
        element={<BatchProcess />}
      />
      <Route
        path={`/${preProRoutes?.mapData}`}
        element={<MapData navigate={navigate} />}
      />
      <Route
        path={`/${preProRoutes?.preProUserPermission}`}
        element={<BatchProcessPreProcessor />}
      />
      <Route path={`/${sharedRoutes?.filesViewer}`} element={<FilesViewer />} />

      <Route
        path={`/${preProRoutes?.createMultipleBatches}`}
        element={<BulkBatchCreation />}
      />
      <Route path={`/*`} element={<PageNotFound />} />
    </Routes>
  );
};

const ProcessorRoutes = () => {
  const navigate = useNavigate(); // Use useNavigate instead of withRouter
  return (
    <Routes>
      <Route
        path={`/${proRoutes?.proDashboard}`}
        element={<ProcessorDashboard />}
      />
      <Route
        path={`/${proRoutes?.dataEntry}`}
        element={<DataEntry navigate={navigate} />}
      />
      <Route
        path={`/${proRoutes?.proUserPermission}`}
        element={<BatchProcessProcessor />}
      />
      <Route path={`/${sharedRoutes?.filesViewer}`} element={<FilesViewer />} />
      <Route path={`/*`} element={<PageNotFound />} />
    </Routes>
  );
};

const ValidatorRoutes = () => {
  const navigate = useNavigate(); // Use useNavigate instead of withRouter
  return (
    <Routes>
      <Route
        path={`/${valiRoutes?.valiDashboard}`}
        element={<ValidatorDashboard />}
      />
      <Route
        path={`/${valiRoutes?.dataValidation}`}
        element={<DataValidation navigate={navigate} />}
      />
      <Route
        path={`/${valiRoutes?.valiUserPermission}`}
        element={<ValidatorUserPermission />}
      />
      <Route path={`/*`} element={<PageNotFound />} />
    </Routes>
  );
};

const AuthRoutes = () => {
  const navigate = useNavigate(); // Use useNavigate instead of withRouter
  return (
    <Routes>
      {/* <Route
        path={`/${authRoutes?.changePassword}`}
        element={<ChangePassword navigate={navigate} />}
      /> */}
      <Route
        path={`/${authRoutes?.forgotPassword}/:token?`}
        element={<PasswordChange navigate={navigate} />}
      />
      <Route path={`/*`} element={<PageNotFound />} />
    </Routes>
  );
};

const AdministratorRoutes = () => (
  <Routes>
    <Route path={`/${adminRoutes?.listPage}`} element={<ListPage />} />
    <Route path={`/${adminRoutes?.addGroup}`} element={<AddGroup />} />
    <Route path={`/${adminRoutes?.manageUser}`} element={<ManageUser />} />
    <Route
      path={`/${adminRoutes?.reviewBatchRecordDetails}`}
      element={<ReviewBatchRecords />}
    />
    <Route path={`/${adminRoutes?.userForm}`} element={<UserForm />} />
    <Route path={`/${adminRoutes?.dataReport}`} element={<DataReport />} />
    <Route path={`/${adminRoutes?.outputList}`} element={<OutputList />} />
    {/* <Route
      path={`/${adminRoutes?.previewOPFileDetails}`}
      element={<PreviewOpFile />}
    /> */}
    <Route
      path={`/${adminRoutes?.auditUserActivity}`}
      element={<AuditUserActivity />}
    />
    <Route path={`/${adminRoutes?.auditList}`} element={<AuditList />} />
    <Route path={`/${adminRoutes?.auditDetails}`} element={<AuditDetails />} />
    <Route
      path={`/${adminRoutes?.listDirectory}`}
      element={<ListDirectory />}
    />
    <Route path={`/${adminRoutes?.batchMonitor}`} element={<BatchMonitor />} />
    <Route path={`/${adminRoutes?.auditHistory}`} element={<AuditHistory />} />
    <Route
      path={`/${adminRoutes?.dataPointCalculation}`}
      element={<DataPointCalculation />}
    />
    <Route
      path={`/${adminRoutes?.dataPointDetails}`}
      element={<DataPointDetails />}
    />
    <Route path={`/${adminRoutes?.mergeOpFiles}`} element={<MergeOpFiles />} />
    <Route
      path={`/${adminRoutes?.uploadBatch}`}
      element={<UploadBatchRecord />}
    />

    <Route path={`/${adminRoutes?.mergePdf}`} element={<MergePDF />} />
    <Route
      path={`/${adminRoutes?.mergePdfSelect}`}
      element={<MergePdfSelect />}
    />
    <Route
      path={`/${adminRoutes?.CreateTemplate}`}
      element={<TemplateCreation />}
    />
    <Route
      path={`/${adminRoutes?.visulization}`}
      element={<VisualizationDashboardTables />}
    />
    <Route
      path={`/${adminRoutes?.batchRejection}`}
      element={<BatchRejection />}
    />
    <Route
      path={`/${adminRoutes?.extractionDetails}`}
      element={<ExtractionDetails />}
    />
    <Route
      path={`/${adminRoutes?.visualizationHistory}`}
      element={<VisualizationHistoryTables />}
    />
    <Route path={`/${adminRoutes?.dataHistory}`} element={<DataHistory />} />
    <Route
      path={`/${adminRoutes?.approvalSettings}`}
      element={<ApprovalSettings />}
    />
    <Route path={`/*`} element={<PageNotFound />} />
  </Routes>
);

const RoutesChild = () => {
  const location = useLocation();

  // Handle the "auth" case separately
  if (
    // location.pathname === "/change-password" ||
    // location.pathname.startsWith("/forgot-password"
    location.pathname === `/${authRoutes.changePassword}` ||
    location.pathname.startsWith(`/${authRoutes.forgotPassword}`)
  ) {
    return <AuthRoutes />;
  }

  // Conditionally render routes based on the user's role
  switch (localStorage?.userRole) {
    case "pre-processor":
      return <PreProcessorRoutes />;
    case "processor":
      return <ProcessorRoutes />;
    case "validator":
      return <ValidatorRoutes />;
    case "administrator":
      return <AdministratorRoutes />;
    default:
      return <PageNotFound />;
  }
};

export default RoutesChild;
